import { Feature } from '@/featureflag_manager';
import { RouteNames } from '@/types/routes';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: 'playground',
    name: RouteNames.PLAYGROUND,
    component: () => import('@/modules/Playground/views/Playground.vue'),
  },
  {
    path: 'chat',
    name: RouteNames.CHAT,
    meta: {
      feature_flag: Feature.CHAT,
    },
    component: () => import('@/modules/Playground/views/Chat.vue'),
  },
];

export default routes;
